import React, { useState } from "react";
import { handleSetReferral } from "../../utlis";
import { formatDate } from "../../utils/patientUtils";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery, 
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import AddIcon from "@mui/icons-material/Add";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import UploadIcon from '@mui/icons-material/Upload';
import PdfTemplate from "../pdfTemplate/pdfTemplate";
import axios from "axios";
import config from "../../config";
import { nextSteps, handleSetDR, getInferenceFromData } from "../../utlis";

const PrintDialogBox = ({ open, setIsDialog, addPatient }) => {
  const [downloadPdfFlag, setDownloadPdfFlag] = useState(false);
  const header = {
    Authorization: "Token " + localStorage.getItem("optha-token"),
  };
  const report_id = localStorage.getItem("report_id");
  const userProfile = JSON.parse(localStorage.getItem("user_profile"));
  const hospital_name = userProfile?.health_facility?.name;
  const [fileName, setFileName] = useState("");
  const [report_data, setReportData] = useState({});
  const [images, setImages] = useState([]);
  // let doc_name = localStorage.getItem("doc_name");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const getReportData = async () => {
    try {
      const response = await axios.get(
        `${config.API_BASE_URL}/api/reports/getreport/?uuid=${report_id}`,
        { headers: header }
      );
      const fetchedReport =  response.data.results[0]
      const blobURLs = await imagetoBase64(fetchedReport.files.left, fetchedReport.files.right); 
      fetchedReport.files.left = blobURLs.left;
      fetchedReport.files.right = blobURLs.right;
      setReportData(fetchedReport);
      
      // Set filename based on patient ID and report number
      const patientId = response.data.results[0].patient?.other_id || response.data.results[0].patient?.abha_id || "Unknown";
      const reportNumber = response.data.results[0]?.number_of_visits || "Unknown";
      setFileName(`Report_${patientId}_${reportNumber}`);
      setDownloadPdfFlag(true);
    } catch (error) {
      console.log(error);
    }
  };
  function imagetoBase64(imageURL1, imageURL2) {
    return Promise.all([fetch(imageURL1), fetch(imageURL2)])
      .then((responses) => Promise.all(responses.map((response) => response.blob())))
      .then((blobs) => {
        // Convert blobs to data URLs instead of blob URLs
        return Promise.all(blobs.map((blob) => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(new Error('Failed to convert to data URL'));
            reader.readAsDataURL(blob);
          });
        }));
      })
      .then((dataURLs) => {
        return {
          left: dataURLs[0],
          right: dataURLs[1],
        };
      })
      .catch((error) => {
        console.error("Error converting images:", error);
        return { left: null, right: null };
      });
  }

  const generatePDF = async () => {
    const element = document.getElementById("pdf-content");
    if (!element) {
      alert("Error: No PDF content to generate.");
      return;
    }

    const html2pdf = (await import("html2pdf.js")).default;

    html2pdf()
      .from(element)
      .set({
        filename: `${fileName || "Diabetic_Retinopathy_Report"}.pdf`,
        image: { type: "jpeg", quality: 1.0 },
        html2canvas: { scale: 3, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        timeout: 10000,
      })
      .save();
  };

  // Calculate inferences and next steps from report_data
  const leftInference = handleSetDR(
    report_data?.ml_model?.classification?.left,
    report_data?.ml_model?.gradibility?.left
  );
  const rightInference = handleSetDR(
    report_data?.ml_model?.classification?.right,
    report_data?.ml_model?.gradibility?.right
  );
  const leftDME = report_data?.ml_model?.model_outputs?.left?.drdme?.DME_grade || null;
  const rightDME = report_data?.ml_model?.model_outputs?.right?.drdme?.DME_grade || null;
  const operatorOverride = report_data?.ml_model?.operator_override || { left: { fundus: false, eye: false }, right: { fundus: false, eye: false } };
  const { date, message } = nextSteps(leftInference, rightInference, leftDME, rightDME, operatorOverride);

const obj = {
    heading: "Diabetic Retinopathy Screening Report",
    patientDetails: [
      {
        label: "Patient ID",
        value:
          report_data.patient?.other_id !== null
            ? report_data.patient?.other_id
            : report_data.patient?.abha_id,
      },
      { label: "Age", value: `${report_data.patient?.age} Y` },
      { label: "Gender", value: `${report_data.patient?.sex[0].toUpperCase()}${report_data.patient?.sex.slice(1)}` },
      { label: "Diabetes", value: `${report_data?.diabetes}` },
      { label: "Reported Vision Issues", value: report_data?.vision_issues?.trim() ? report_data.vision_issues : "Unknown" },
      // { label: "Phone Number:", value: `+91 ${report_data.patient?.phone}` },
      // { label: "Referred by:", value: `Dr. ${report_data.doctor?.user?.name}` },
    ],
    url: report_data?.uuid,
    images: {
      img1: images[0],
      img2: images[1],
    },
    reportCount: report_data?.number_of_visits,
    // nextSteps:
    //   `${report_data.ml_model?.nextSteps ||
    //               "Referral required within 3-6 months and suggest sugar monitoring."}`,
    hospitalVisit:
      `If you’re looking for a medical advise,visit ${hospital_name} Hospital.`,
    disclaimer:
      "MadhuNetrAI, an AI-based Diabetic Retinopathy Screening application, has been developed under the guidance and supervision of qualified doctors from AIIMS New Delhi and AIIMS Rishikesh. However, the AI interpretation is only a prediction, and the final decision rests with the attending doctor. The E-Health division of the Ministry of Health and Family Welfare & Wadhwani AI—the AI Unit of the Lords Education and Health Society (LEHS)—disclaims any liability, claims, or disputes arising from the use of this application. The information, including but not limited to text, graphics, images, and other material contained in this application, are for informational purposes only. No material on this application is intended to be a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of a qualified healthcare provider and never disregard professional medical advice or delay in seeking it because of something you have read or seen on this application.",
  };
  return (
    <>
      <div style={{ display: "none" }}>
        <div id="pdf-content">
        {downloadPdfFlag && (
            <PdfTemplate
                downloadFlag={downloadPdfFlag}
                fileName={fileName}
                heading={obj.heading}
                reportindex={obj.reportCount}
                visitDate={formatDate(report_data.created_at || report_data.createdAt)}
                patientDetails={obj.patientDetails}
                // url={obj.url}
                images={{ img1: report_data.files?.left, img2: report_data.files?.right }}
                // healthInfo={obj.healthInfo}
                // notes={obj.notes}
                nextSteps={[null, message]}
                // hospitalVisit={obj.hospitalVisit}
                disclaimer={obj.disclaimer}
                // setDownloadFlag={setDownloadPdfFlag}
              leftInference={leftInference}
              rightInference={rightInference}
              leftDME={report_data?.ml_model?.model_outputs?.left?.drdme?.DME_grade || null}
              rightDME={report_data?.ml_model?.model_outputs?.right?.drdme?.DME_grade || null}
              operatorOverride={report_data?.ml_model?.operator_override || { left: { fundus: false, eye: false }, right: { fundus: false, eye: false } }}
              required={handleSetReferral(
                report_data?.feedback_data?.left_eye_correct_inference || getInferenceFromData(report_data?.ml_model?.classification?.left, report_data?.ml_model?.model_outputs?.left),
                report_data?.feedback_data?.right_eye_correct_inference || getInferenceFromData(report_data?.ml_model?.classification?.right, report_data?.ml_model?.model_outputs?.right),
                report_data?.single_image_reason,
                report_data?.ml_model?.operator_override || { left: { fundus: false, eye: false }, right: { fundus: false, eye: false } },
                { left: report_data?.ml_model?.model_outputs?.left?.drdme?.DME_grade || null, right: report_data?.ml_model?.model_outputs?.right?.drdme?.DME_grade || null }
              )}
              singleImageReason={report_data?.single_image_reason}
            />
            )}
          </div>
        </div>
        <div>
            <Dialog
                open={open}
                width="lg"
                maxWidth="lg"
                height="md"
                borderRadius="16px"
                sx={{
                    boxShadow:
                        "0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 6px 0px rgba(0, 0, 0, 0.02)",
                    
                }}
            >
                <DialogTitle display="flex" justifyContent="end" alignItems="center">
                    <Button
                        endIcon={<CloseIcon />}
                        onClick={() => {
                            setIsDialog(false);
                            localStorage.removeItem("report_id");
                            localStorage.removeItem("doc_name");
                        }}
                        sx={{
                            color: "#0D1E83",
                            "&:hover": { backgroundColor: "var(--Blue, #FFFFFF)" },
                            textTransform: "none",
                        }}
                    >
                        {!isMobile && "Close"}
                    </Button>
                </DialogTitle>
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        // paddingX: "40px",
                        paddingLeft: "40px",
                        paddingRight: "40px",
                    }}
                    className="dialogContent"
                    >
                    <TaskAltIcon
                        sx={{ color: "#00850D", height: "60px", width: "60px" }}
                    />
                    <Typography
                        display="flex"
                        color="#2D363D"
                        fontSize="24px"
                        fontWeight={500}
                        gap={0.5}
                        alignItems="center"
                        whiteSpace="nowrap"
                        overflowX="hidden"
                    >
                        Report Submitted
                        <Typography color="#00850D" fontSize="24px" fontWeight={600}>
                            Successfully
                        </Typography>
                    </Typography>
                    {/* <Typography
                        color="#404040"
                        fontWeight={500}
                        fontSize="17px"
                        textAlign="center"
                    >
                        {`The report has been successfully sent to
                        Ophthalmologist at AIIMS Delhi`}
                    </Typography> */}
                </DialogContent>
                <DialogActions
                    width="100%"
                    display="flex"
                    sx={{ flexDirection: isMobile ? "column" : "row", justifyContent: "space-evenly", paddingX: "44px", marginBottom: "15px" }} 
                    className="dialogActions"
                >
                     <Button
                        sx={{
                            order: isMobile ? 2 : 1,
                            borderRadius: "8px",
                            border: "2px solid var(--Blue, #0D1E83)",
                            color: "#0D1E83",
                            "&:hover": { backgroundColor: "var(--Blue, #FFFFFF)" },
                            textTransform: "none" 
                        }}
                        onClick={async () => {
                          await getReportData();
                          setTimeout(() => generatePDF(), 1000); // slight delay to ensure images load
                        }}
                        startIcon={<UploadIcon />}
                    >
                        Export Report
                    </Button>

                    <Button
                        variant="contained"
                        sx={{
                            order: isMobile ? 1 : 2,
                            borderRadius: "8px",
                            border: "2px solid var(--Blue, #0D1E83)",
                            background: "var(--Blue, #0D1E83)",
                            color: "#FFFFFF",
                            whiteSpace: "nowrap",
                            "&:hover": { backgroundColor: "var(--Blue, #0D1E83)" },
                            textTransform: "none" 
                        }}
                        onClick={addPatient}
                        startIcon={<AddIcon />}
                    >
                        Add New Patient
                    </Button>
                   
                </DialogActions>
            </Dialog>
        </div>
    </>
);

};

export default PrintDialogBox;
